import { chakra, Box, Text } from "@chakra-ui/react"
import { space } from "theme/themeConfig"

export const Container = chakra(Box, {
  baseStyle: {
    pb: space["1"],
  },
})

export const PricingContainer = chakra(Box, {
  baseStyle: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
})
export const PriceText = chakra(Text, {
  baseStyle: {
    marginTop: 0,
    fontWeight: "bold",
    display: "inline-block",
    marginLeft: "3px",
  },
})
export const PriceDiscountText = chakra(Text, {
  baseStyle: {
    marginTop: 0,
    textAlign: "right",
  },
})
